import { BuildType } from '@/services/ApiService.ts';
import { UserCustomSkillModel, UserSkillModel } from '@/apiTypes/UserTypes.ts';

export const userSkillApiEndpoints = (build: BuildType) => ({
    getUserSkills: build.query<UserSkillModel[], void>({
        query: () => 'user/skills',
        providesTags: ['UserSkills'],
    }),
    deleteUserSkill: build.mutation<void, string>({
        query: id => ({
            url: `/user/skills/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['UserSkills', 'UserJourneys'],
    }),
    updateUserSkills: build.mutation<UserSkillModel[], UserSkillModel[]>({
        query: skillDetails => ({
            url: 'user/skills',
            method: 'POST',
            body: { skillDetails },
        }),
        invalidatesTags: ['UserSkills', 'UserJourneys'],
    }),
    getUserCustomSkills: build.query<UserCustomSkillModel[], void>({
        query: () => 'user/custom-skills',
        providesTags: ['UserCustomSkills'],
    }),
    deleteUserCustomSkill: build.mutation<void, string>({
        query: id => ({
            url: `/user/custom-skills/${id}`,
            method: 'DELETE',
        }),
        invalidatesTags: ['UserCustomSkills', 'UserJourneys'],
    }),
    updateUserCustomSkills: build.mutation<UserCustomSkillModel[], UserCustomSkillModel[]>({
        query: skillDetails => ({
            url: 'user/custom-skills',
            method: 'POST',
            body: { skillDetails },
        }),
        invalidatesTags: ['UserCustomSkills', 'UserJourneys'],
    }),
    bulkDeleteUserSkills: build.mutation<
        { userSkillsDeleted: number; customSkillsDeleted: number },
        { skillIds: string[]; customSkillIds: string[] }
    >({
        query: ({ skillIds, customSkillIds }) => ({
            url: 'user/skills/bulk-delete',
            method: 'POST',
            body: { skillIds, customSkillIds },
        }),
        invalidatesTags: ['UserSkills', 'UserCustomSkills', 'UserJourneys'],
    }),
});
